(function () {
  'use strict';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function lockBody(lock) {
    document.documentElement.classList.toggle('n1-menu-open', !!lock);
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function destroyController(el, key) {
    if (!el || !el[key]) return;
    el[key].abort();
    el[key] = null;
  }

  function initHero(hero) {
    if (!hero) return;
    if (hero.dataset.n1Init === 'true') {
      initHeroMenu(hero);
      return;
    }
    hero.dataset.n1Init = 'true';
    hero.querySelectorAll('.n1-hero__headline-line').forEach(function (line) {
      if (line.querySelector('span')) return;
      var s = document.createElement('span');
      s.textContent = line.textContent;
      line.textContent = '';
      line.appendChild(s);
    });
    requestAnimationFrame(function () { hero.classList.add('n1-hero--ready'); });
    initHeroMenu(hero);
  }

  function initHeroMenu(hero) {
    var toggle = hero.querySelector('[data-n1-menu-toggle]');
    var drawer = hero.querySelector('[data-n1-menu]');
    var closeBtn = hero.querySelector('[data-n1-menu-close]');
    if (!toggle || !drawer) return;

    destroyController(hero, '_n1MenuAc');
    var ac = new AbortController();
    hero._n1MenuAc = ac;
    var signal = ac.signal;

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      lockBody(false);
    }

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      lockBody(true);
      if (closeBtn) closeBtn.focus();
    }

    toggle.addEventListener('click', function () {
      drawer.classList.contains('is-open') ? close() : open();
    }, { signal: signal });

    if (closeBtn) {
      closeBtn.addEventListener('click', close, { signal: signal });
    }

    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) close();
    }, { signal: signal });

    drawer.querySelectorAll('a[href]').forEach(function (link) {
      link.addEventListener('click', close, { signal: signal });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    }, { signal: signal });
  }

  function setAnswerOpen(answer, open) {
    if (!answer) return;
    if (open) {
      answer.hidden = false;
      answer.setAttribute('aria-hidden', 'false');
    } else {
      var delay = document.documentElement.classList.contains('n1-motion-enabled') && !REDUCED ? 420 : 0;
      answer.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () {
        if (answer.closest('[data-n1-faq-item]') && !answer.closest('[data-n1-faq-item]').classList.contains('is-open')) {
          answer.hidden = true;
        }
      }, delay);
    }
  }

  function initFaq(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-n1-faq-toggle]').forEach(function (btn) {
      if (btn.dataset.n1Bound === 'true') return;
      btn.dataset.n1Bound = 'true';
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-n1-faq-item]');
        if (!item) return;
        var answer = item.querySelector('.n1-faq__answer');
        var open = item.classList.contains('is-open');
        var faq = item.closest('[data-n1-faq]');
        if (faq) {
          faq.querySelectorAll('[data-n1-faq-item].is-open').forEach(function (i) {
            if (i !== item) {
              i.classList.remove('is-open');
              setAnswerOpen(i.querySelector('.n1-faq__answer'), false);
              var t = i.querySelector('[data-n1-faq-toggle]');
              if (t) t.setAttribute('aria-expanded', 'false');
            }
          });
        }
        item.classList.toggle('is-open', !open);
        setAnswerOpen(answer, !open);
        btn.setAttribute('aria-expanded', !open ? 'true' : 'false');
      });
    });
  }

  function initPageHeader(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-n1-page-header], .n1-page-header').forEach(function (header) {
      var toggle = header.querySelector('[data-n1-page-menu-toggle]');
      var drawer = header.querySelector('[data-n1-page-menu]');
      if (!toggle || !drawer) return;

      destroyController(header, '_n1PageMenuAc');
      var ac = new AbortController();
      header._n1PageMenuAc = ac;
      var signal = ac.signal;

      function close() {
        drawer.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        lockBody(false);
      }

      function open() {
        drawer.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        lockBody(true);
      }

      toggle.addEventListener('click', function () {
        drawer.hidden ? open() : close();
      }, { signal: signal });

      drawer.querySelectorAll('a[href]').forEach(function (link) {
        link.addEventListener('click', close, { signal: signal });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !drawer.hidden) close();
      }, { signal: signal });
    });
  }

  function initFitForm(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-n1-fit-form]').forEach(function (form) {
      if (form.dataset.n1Bound === 'true') return;
      form.dataset.n1Bound = 'true';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var result = form.querySelector('[data-n1-fit-result]');
        if (result) {
          result.hidden = false;
          result.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'nearest' });
        }
      });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-n1-hero]').forEach(initHero);
    initFaq();
    initFitForm();
    initPageHeader();
  });

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target;
    var hero = target.querySelector('[data-n1-hero]') || (target.matches && target.matches('[data-n1-hero]') ? target : null);
    if (hero) {
      destroyController(hero, '_n1MenuAc');
      hero.dataset.n1Init = '';
      hero.classList.remove('n1-hero--ready');
      initHero(hero);
    }
    var header = target.querySelector('[data-n1-page-header], .n1-page-header') || (target.matches && target.matches('.n1-page-header') ? target : null);
    if (header) {
      destroyController(header, '_n1PageMenuAc');
      initPageHeader(header.parentNode || document);
    }
    initFaq(target);
    initFitForm(target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var target = e.target;
    var hero = target && (target.querySelector('[data-n1-hero]') || (target.matches && target.matches('[data-n1-hero]') ? target : null));
    if (hero) destroyController(hero, '_n1MenuAc');
    var header = target && (target.querySelector('[data-n1-page-header], .n1-page-header') || (target.matches && target.matches('.n1-page-header') ? target : null));
    if (header) destroyController(header, '_n1PageMenuAc');
    lockBody(false);
  });
})();
